import { NavBar } from 'antd-mobile'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'

export const Policy: React.FC = () => {
  const isMobile = location.search.includes('mobile')
  const history = useHistory()
  useEffect(() => {
    document.title = 'growp隐私政策'
  }, [])
  return (
    <>
      {isMobile ? (
        <StyledNavBar
          back="隐私政策"
          backArrow={
            <GrowpIcon
              name="Right"
              size="0.42rem"
            />
          }
          onBack={() => {
            history.goBack()
          }}
        />
      ) : (
        <FirstLevelTitle>隐私政策</FirstLevelTitle>
      )}
      <Wrapper>
        <Paragraph>
          <Paragraph>
            本政策仅适用于Growp（以下简称“Growp”）产品或服务。
          </Paragraph>
          <Paragraph>
            本隐私政策将帮助您了解：
            <br />
            我们会遵循隐私政策收集、使用您的信息，但不会仅因您同意本隐私政策而采用强制捆绑的方式一揽子收集个人信息。
            当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现基本业务功能或根据法律法规要求必要信息，您均可以拒绝提供且不影响其他功能或服务。我们将在隐私政策中逐项说明哪些是必要信息。
            如果您未登录帐号，我们会通过设备对应的标识符信息来保障信息推送的基本功能。如果您登录了账号，我们会根据账号信息实现信息推送。
            摄像头、麦克风、相册（存储）、日历权限，均不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用，您也可以撤回授权。特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。
            <br />
            具体权限申请与使用情况请见：Growp应用权限申请与使用情况说明 第三方
            SDK
            <br />
            接入情况请见：Growp应用第三方 SDK 接入情况说明
          </Paragraph>
          <SecondTitle>一、适用范围</SecondTitle>
          <Paragraph>
            为用户提供更好、更优的服务是Growp坚持不懈的追求，也希望通过Growp提供的服务可以更方便您的生活。本隐私权政策适用于Growp提供的所有服务，您访问Growp提供的服务，均适用本隐私权政策。
            需要特别说明的是，本隐私权政策不适用于其他第三方向您提供的服务，例如您与平台上的其他用户依托平台进行对话时，您向他人提供的个人信息不适用于本隐私权政策。
          </Paragraph>
          <SecondTitle>二、Growp如何收集信息</SecondTitle>
          <Paragraph>
            Growp收集信息是为了向您提供更好、更优的服务，Growp收集信息的方式如下：
            <br />
            1. 您向Growp提供的信息。
            <br />
            当您注册Growp帐户及您在使用Growp提供的相关服务时填写及/或提交的信息，包括您的姓名、性别、出生年月日、身份证号码、护照姓、护照名、护照号码、电话号码、电子邮箱、地址及相关附加信息（如您所在的省份和城市、邮政编码等）。
            <br />
            2. 在您使用服务过程中收集的信息。
            <br />
            为了提供并优化您需要的服务，Growp会收集您使用服务的相关信息，这类信息包括：在您使用Growp服务时，Growp自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；如您下载或使用Growp或其关联公司客户端软件，或访问移动网页使用平台服务时，Growp可能会读取与您位置和移动设备相关的信息，包括但不限于设备型号、设备识别码、操作系统、分辨率、电信运营商等。
            <br />
            除上述信息外，Growp还可能为了提供服务及改进服务质量的合理需要而收集您的其他信息，包括您与Growp的客户服务团队联系时您提供的相关信息，您参与问卷调查时向Growp发送的问卷答复信息，以及您与Growp的关联方、Growp的合作伙伴之间互动时Growp收集的相关信息。与此同时，为提高您使用Growp提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，Growp可能会通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账户的风险，并可能会记录一些Growp认为有风险的URL。
            <br />
            您了解并同意，以下信息不适用本隐私权政策： <br />
            a. 您在使用Growp平台提供的搜索服务时输入的关键字信息； <br />
            b. 信用评价、违反法律规定或违反平台规则行为及Growp已对您采取的措施；{' '}
            <br />
            c.
            应法律法规要求需公示的企业名称等相关工商注册信息以及自然人经营者的信息。
          </Paragraph>
          <SecondTitle>三、Growp如何使用信息</SecondTitle>
          <Paragraph>
            因收集您的信息是为了向您提供服务及提升服务质量的目的，为了实现这一目的，Growp会把您的信息用于下列用途：
            <br />
            1. 向您提供您使用的各项服务，并维护、改进这些服务。 <br />
            2.
            Growp可能使用您的个人信息以预防、发现、调查欺诈、危害安全、非法或违反与Growp或其关联方协议、政策或规则的行为，以保护您、其他Growp用户，或Growp或其关联方的合法权益。
            <br />
            3. 经您许可的其他用途。
            <br />
            如果对您信息的使用超过了上述范围，Growp会重新取得您的授权。
          </Paragraph>
          <SecondTitle>四、Growp如何共享信息</SecondTitle>
          <Paragraph>
            Growp对您的信息承担保密义务，不会为满足第三方的营销目的而向其出售或出租您的任何信息，Growp会在下列情况下才将您的信息与第三方共享：
            <br />
            1. 事先获得您的同意或授权。
            <br /> 2. 根据法律法规的规定或行政或司法机构的要求。 <br />
            3. 向Growp的关联方分享您的个人信息。
            <br /> 4.
            向可信赖的合作伙伴提供您的个人信息，让他们根据Growp的指示并遵循Growp的隐私权政策以及其他任何相应的保密和安全措施来为Growp处理这些信息。
            <br />
            5.
            只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。
            <br />
            6.
            如您出现违反中国有关法律、法规或者Growp相关协议或相关规则的情况，需要向第三方披露。
            <br />
            7. 为维护Growp及其关联方或用户的合法权益。
          </Paragraph>
          <SecondTitle>五、Cookie和网络Beacon的使用</SecondTitle>
          <Paragraph>
            为使您获得更轻松的访问体验，您访问Growp或使用平台提供的服务时，Growp可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash
            Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。
            <br />
            请您理解，Growp的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝Growp的Cookie，但这一举动在某些情况下可能会影响您安全访问Growp和使用平台提供的服务。
            <br />
            网页上常会包含一些电子图象（称为"单像素" GIF 文件或 "网络
            beacon"），使用网络beacon可以帮助网站计算浏览网页的用户或访问某些cookie，Growp会通过网络beacon收集您浏览网页活动的信息，例如您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定等。
          </Paragraph>
          <SecondTitle>六、信息存储</SecondTitle>
          <Paragraph>
            Growp收集的有关您的信息和资料将保存在Growp及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或Growp收集信息和资料所在地并在该地被访问、存储和展示。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非您同意延长保留期或受到法律的允许。
          </Paragraph>
          <SecondTitle>七、您的个人信息保护</SecondTitle>
          <Paragraph>
            为保障您的信息安全，Growp努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。Growp对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。Growp会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，Growp将尽力做到使您的信息不被泄漏、毁损或丢失。
            <br />
            您的帐户均有安全保护功能，请妥善保管您的帐户及密码信息。Growp将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。
            <br />
            在使用Growp时，您可能会与其他用户进行线上交流。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的帐户及密码发生泄露，请您立即联络Growp，以便Growp采取相应措施。
          </Paragraph>
          <SecondTitle>八、未成年人保护</SecondTitle>
          <Paragraph>
            Growp重视未成年人的个人信息保护，如您为未成年人，建议您请您的监护人仔细阅读本隐私权政策，并在征得您的监护人同意的前提下使用Growp的服务或向Growp提供信息。
          </Paragraph>
        </Paragraph>
      </Wrapper>
    </>
  )
}

export const Agreement: React.FC = () => {
  const isMobile = location.search.includes('mobile')
  const history = useHistory()
  useEffect(() => {
    document.title = 'growp服务协议'
  }, [])

  return (
    <>
      {isMobile ? (
        <StyledNavBar
          back="服务协议"
          backArrow={
            <GrowpIcon
              name="Right"
              size="0.42rem"
            />
          }
          onBack={() => {
            history.goBack()
          }}
        />
      ) : (
        <FirstLevelTitle>服务协议</FirstLevelTitle>
      )}
      <Wrapper>
        <Paragraph>
          <Paragraph>欢迎使用Growp产品及服务！</Paragraph>
          <Paragraph>
            提示：在使用Growp产品及服务之前，您应当认真阅读并遵守《Growp用户协议》（以下简称“本协议”）以及《Growp
            隐私权政策》。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、争议解决和法律适用条款。
            <br />
            当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，或您按照激活页面提示填写信息、阅读并同意本协议且完成全部激活程序后，或您以其他Growp允许的方式实际使用本服务时，即表示您已充分阅读、理解并接受本协议的全部内容，本协议即产生法律约束力。您承诺接受并遵守本协议的约定，届时您不应以未阅读本协议的内容或者未获得Growp对您问询的解答等理由，主张本协议无效或要求撤销本协议。
          </Paragraph>
          <SecondTitle>1. 接受条款</SecondTitle>
          <ListTitle>
            {' '}
            1.1
            我们提供的服务根据本协议的条款为用户提供服务；用户一旦登录成功，无论是进入我们提供的服务，还是在我们提供的服务上发布任何内容，均意味着用户完全接受本协议项下的全部条款。
          </ListTitle>
          <ListTitle>
            1.2
            用户使用我们提供的单项服务时，应遵守与该服务相关的指引和规则。所有的指引和规则，均构成本使用协议的一部分。
          </ListTitle>
          <ListTitle>
            1.3 用户直接或通过各类方式（如 RSS 源和站外 API
            引用等）间接使用我们提供的服务和数据的行为，都将被视作已无条件接受本协议全部内容。
          </ListTitle>
          <ListTitle>
            1.4
            若用户对本协议的任何条款存在异议，请停止使用我们所提供的全部服务。
          </ListTitle>
          <ListTitle>
            1.5
            用户应遵守本协议各项条款，合法合理使用我们提供的服务；否则，我们有权依据本协议终止为用户提供服务。
          </ListTitle>
          <ListTitle>
            1.6 我们保留在任何时候收回用户所使用账号的权利。
          </ListTitle>
          <br />
          <SecondTitle>2. 使用规则</SecondTitle>{' '}
          <ListTitle>
            2.1
            用户须对在我们提供的服务的登录信息的真实性、合法性、有效性承担全部责任，用户不得冒充他人；不得利用他人的名义发布任何信息；不得恶意使用帐号导致其他用户误认。
          </ListTitle>
          <ListTitle>
            2.2
            您应自行承担因使用服务所产生的费用，包括但不限于上网流量费、通信服务费等。
          </ListTitle>
          <ListTitle>
            2.3
            除非另有说明，本协议项下的服务只能用于非商业用途。您承诺不对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于包括但不限于广告及任何其它商业目的。
          </ListTitle>
          <ListTitle>
            2.4
            用户不得利用我们提供的服务制作、上传、复制、发布、传播或者转载如下内容：
          </ListTitle>
          <StyledUl>
            <li>反对宪法所确定的基本原则的；</li>
            <li>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
            <li>
              损害国家荣誉和利益的； 煽动民族仇恨、民族歧视，破坏民族团结的；
            </li>
            <li>侮辱、滥用英烈形象，否定英烈事迹，美化粉饰侵略战争行为的；</li>
            <li>破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
            <li>散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
            <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
            <li>侮辱或者诽谤他人，侵害他人合法权益的；</li>
            <li>
              含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其他道德上令人反感的内容；
            </li>
            <li>
              含有中国法律、法规、（部门）规章以及任何具有法律效力之规范所限制或禁止的其他内容的；
            </li>
            <li>含有我们提供的服务认为不适合在我们提供的服务展示的内容。</li>
          </StyledUl>
          <SecondTitle>3. 知识产权</SecondTitle>
          <ListTitle>
            {' '}
            3.1
            用户在我们提供的服务上发表的全部原创内容（包括但不仅限于讨论和评论），著作权均归用户本人所有。用户可授权第三方以任何方式使用，不需要得到我们提供的服务的同意。
          </ListTitle>
          <ListTitle>
            3.2
            第三方若出于非商业目的，将用户在我们提供的服务上发表的原创内容转载在我们提供的服务之外的地方，应当在作品的正文开头的显著位置注明原作者姓名（或原作者在我们提供的服务上使用的帐号名称），给出我们提供的服务原始链接，注明「发表于我们提供的服务」，并不得对作品进行修改演绎。若需要对作品进行修改，或用于商业目的，第三方应当联系用户获得单独授权，按照用户规定的方式使用该内容。
          </ListTitle>
          <ListTitle>
            3.3
            在我们提供的服务上传或发表的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，我们提供的服务有权根据实际情况删除相关的内容，且有权追究用户的法律责任。给我们提供的服务或任何第三方造成损失的，用户应负责全额赔偿。
          </ListTitle>
          <ListTitle>
            3.4
            如果任何第三方侵犯了我们提供的服务用户相关的权利，用户同意授权我们提供的服务或其指定的代理人代表我们提供的服务自身或用户对该第三方提出警告、投诉、发起行政执法、诉讼、进行上诉，或谈判和解，并且用户同意在我们提供的服务认为必要的情况下参与共同维权。
          </ListTitle>
          <ListTitle>
            3.5
            我们提供的服务有权但无义务对用户发布的内容进行审核，有权根据相关证据结合《侵权责任法》、《信息网络传播权保护条例》等法律法规及我们提供的服务指导原则对侵权信息进行处理。
          </ListTitle>
          <br />
          <SecondTitle>4. 免责申明</SecondTitle>{' '}
          <ListTitle>
            4.1
            我们提供的服务不能对用户发布的内容或评论的安全性、正确性进行保证。
          </ListTitle>
          <ListTitle>
            {' '}
            4.2
            用户在我们提供的服务发表的内容仅表明其个人的立场和观点，并不代表我们提供的服务的立场或观点。作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。我们提供的服务不承担任何法律及连带责任。
          </ListTitle>
          <ListTitle>
            4.3
            我们提供的服务不保证网络服务一定能满足用户的要求，也不保证网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作保证。
          </ListTitle>
          <ListTitle>
            4.4
            对于因不可抗力或我们提供的服务不能控制的原因造成的网络服务中断或其它缺陷，我们提供的服务不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。
          </ListTitle>
          <br />
          <SecondTitle>5. 协议修改</SecondTitle>{' '}
          <ListTitle>
            5.1
            根据互联网的发展和有关法律、法规及规范性文件的变化，或者因业务发展需要，我们提供的服务有权对本协议的条款作出修改或变更，一旦本协议的内容发生变动，我们提供的服务将会在网站上公布修改之后的协议内容，该公布行为视为我们提供的服务已经通知用户修改内容。
          </ListTitle>
          <ListTitle>
            5.2
            如果不同意我们提供的服务对本协议相关条款所做的修改，用户有权并应当停止使用我们提供的服务。如果用户继续使用我们提供的服务，则视为用户接受我们提供的服务对本协议相关条款所做的修改。
          </ListTitle>
        </Paragraph>
      </Wrapper>
    </>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: calc(100% - 1.17rem);
  overflow-y: scroll;
  padding: 24px 20px;
`
const FirstLevelTitle = styled.div`
  width: 100%;
  margin-bottom: 48px;
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  color: #152529;
`

const SecondTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #152529;
`

const ListTitle = styled.div``

const StyledUl = styled.ul`
  padding-left: 20px;
`

const Paragraph = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`

const StyledNavBar = styled(NavBar)`
  width: 100vw;
  height: 1.17rem;
  background-color: #ffffff;
`
